"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TableRow2 = _interopRequireDefault(require("@material-ui/core/TableRow"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _TableRow3 = _interopRequireDefault(require("./TableRow.styles"));

var TableRow = function TableRow(props) {
  var className = props.className,
      zebra = props.zebra,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["className", "zebra"]);
  var classes = (0, _TableRow3.default)({
    zebra: zebra
  });
  return /*#__PURE__*/_react.default.createElement(_TableRow2.default, Object.assign({}, otherProps, {
    className: (0, _classnames.default)('pds-table__row', className),
    classes: classes
  }));
};

TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: _propTypes.node,

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: _propTypes.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: _propTypes.bool,

  /**
   * If `true`, the table row will have zebra shading if row number is odd.
   */
  zebra: _propTypes.bool
};
var _default = TableRow;
exports.default = _default;
